import React, { useState, useEffect, useRef } from "react";
// import YouthLogoDark from "../../../assets/images/youth_logo_dark.png";
import YouthLogoLight from "../../../assets/images/youth_logo_light.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { formDataHelper, notify } from "../../../util/helpers";
import eyeopen from "../../../assets/icons/eye-open.svg";
import eyeclose from "../../../assets/icons/EyeClose.svg";
import {
  checkAccountExistsLogic,
  registerCaregiverLogic,
} from "../../../store/features/app/appSlice";
import { Helmet } from "react-helmet";
import { isEmptyObject } from "jquery";
import YouthCaregiverLogo from "../../../assets/images/caregiver_left_logo.svg";
import YouthLogoDark from "../../../assets/images/Precise_Digiatl_youth_Login_ Logo.svg";

/* -------------------------------------------
 * Password Policy Helpers
 * -----------------------------------------*/
const getPasswordChecklist = (password) => ({
  length: password.length >= 12,
  upper: /[A-Z]/.test(password),
  lower: /[a-z]/.test(password),
  number: /[0-9]/.test(password),
  special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
});

const isStrongPassword = (password) => {
  const minLength = 12;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasDigit = /[0-9]/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  return (
    password.length >= minLength &&
    hasUpperCase &&
    hasLowerCase &&
    hasDigit &&
    hasSpecialChar
  );
};



const NewUserComponent = ({ setPreviousData, setUserType, userType }) => {
  const passwordField = useRef();
  const passwordIcon = useRef();
  const navigate = useNavigate();
  const { loading, user } = useSelector((state) => state.app);
  const originURL = window.location.origin;
  const [password, setPassword] = useState("");
  const [checklist, setChecklist] = useState(getPasswordChecklist(""));

  useEffect(() => {
    if (user) {
      if (user?.role !== "CAREGIVER" || !originURL.includes("youth")) {
        if (originURL !== "http://localhost:3000") {
          navigate("/dashboard/home/");
        }
      }
    }
  }, []);

  const toggleVisibility = () => {
    if (passwordField.current.type === "password") {
      passwordField.current.type = "text";
      passwordIcon.current.src = eyeclose;
    } else {
      passwordField.current.type = "password";
      passwordIcon.current.src = eyeopen;
    }
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();

    const formData = new FormData(evt.target);
    const data = {};
    formData.forEach((value, key) => {
      data[key] = value.trim();
    });

    const isValid = Object.values(data).every((value) => value.length > 0);
    if (!isValid) {
      notify("Enter valid data!", "error");
      return;
    }

    // Password policy check
    if (!isStrongPassword(data.password)) {
      notify(
        "Password must be at least 12 characters long and include uppercase, lowercase, a number, and a special character.",
        "error"
      );
      return;
    }

    setPreviousData(data);
    setUserType("step-2");
  };
  return (
    <form
      onSubmit={handleSubmit}
      className="container"
      style={{ display: userType === "new" ? "block" : "none" }}
    >
      <div className="container-fluid">
        <h2 className="primary-text-blue">Create Account</h2>
      </div>
      <div className="container mt-2">
        <div className="form-group py-2">
          <label>
            <strong>First Name</strong>
          </label>
          <input
            required={true}
            style={{ marginTop: "6px" }}
            placeholder="Enter first name"
            name="first_name"
            id="first_name"
          />
        </div>
        <div className="form-group py-2">
          <label>
            <strong>Last Name</strong>
          </label>
          <input
            required={true}
            style={{ marginTop: "6px" }}
            placeholder="Enter Last name"
            name="last_name"
            id="last_name"
          />
        </div>
        <div className="form-group py-2">
          <label>
            <strong>Contact</strong>
          </label>
          <input
            required={true}
            style={{ marginTop: "6px" }}
            placeholder="Enter contact number"
            type="tel"
            name="contact"
            id="contact"
          />
        </div>
        <div className="form-group py-2">
          <label>
            <strong>Email</strong>
          </label>
          <input
            required={true}
            style={{ marginTop: "6px" }}
            placeholder="Enter email"
            name="email"
            id="email"
          />
        </div>
        <div className="form-group py-2">
          <label>
            <strong>Your Password</strong>
          </label>
          <div style={{ position: "relative" }}>
            <input
              required={true}
              style={{ marginTop: "6px" }}
              type="password"
              name="password"
              id="password"
              placeholder="Enter Your Password"
              ref={passwordField}
              onChange={(e) => {
                setPassword(e.target.value);
                setChecklist(getPasswordChecklist(e.target.value));
              }}
            />
            <img
              src={eyeopen}
              ref={passwordIcon}
              onClick={toggleVisibility}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                cursor: "pointer",
              }}
              alt="Show Password"
              height="25px"
              width="25px"
            />
          </div>

          {/* Password Checklist */}
          <div aria-live="polite" className="password-guidelines mt-2">
            <ul className="password-checklist">
              <li style={{ color: checklist.length ? "green" : "red" }}>
                Minimum 12 characters
              </li>
              <li style={{ color: checklist.upper ? "green" : "red" }}>
                At least one uppercase letter
              </li>
              <li style={{ color: checklist.lower ? "green" : "red" }}>
                At least one lowercase letter
              </li>
              <li style={{ color: checklist.number ? "green" : "red" }}>
                At least one number
              </li>
              <li style={{ color: checklist.special ? "green" : "red" }}>
                At least one special character
              </li>
            </ul>
          </div>
        </div>

        <br />
        <div className="container-fluid text-center py-3">
          <button
            type="submit"
            disabled={loading}
            className="primary-btn"
            style={{ width: "100%" }}
          >
            Enter Child Details {">"}
          </button>
        </div>
      </div>
    </form>
  );
};

const AdolescentDetails = ({ previousData, setUserType, userType }) => {
  const [childEmail, setChildEmail] = useState("");
  const handleSubmit = (event) => {
    event.preventDefault();
    checkAccountExistsLogic({ email: childEmail })
      .then((res) => {
        if (res.status === 200) {
          if (res.data === false) {
            notify("This account doesn't seem to exist!", "info");
            return;
          }
          const data = { ...previousData };
          data["assessment_list"] = [26, 11]; //* Starting the patient off with some default assessments.
          data["patient_email"] = childEmail;
          dispatch(registerCaregiverLogic(data));
        }
      })
      .catch((e) => {
        notify("Something went wrong!", "error");
        notify("Please verify your data and try again!", "info");
        setUserType("new"); //Taking the user back to step-1 of registation with pre-filled data.
      })
      .catch((e) => {
        notify("This account doesn't seem to exist!", "error");
      });
  };
  const { loading } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  return (
    <div
      className="container"
      style={{ display: userType === "step-2" ? "block" : "none" }}
    >
      <div className="container-fluid">
        <h3 className="primary-text-blue">
          Enter Adolescent details to complete your registration
        </h3>
      </div>
      <form onSubmit={handleSubmit} className="container mt-5">
        <div className="form-group py-2">
          <label>
            <strong>Email address associated with their account</strong>
          </label>
          <input
            placeholder="Enter Email Address"
            name="patient_email"
            id="patient_email"
            style={{ marginTop: "6px" }}
            value={childEmail}
            onInput={(e) => {
              setChildEmail(e.target.value);
            }}
          />
        </div>
        <br />
        <div className="container-fluid text-center py-4">
          <button
            type="submit"
            onClick={handleSubmit}
            disabled={loading}
            className="primary-btn"
            style={{ width: "100%" }}
          >
            Complete Sign Up
          </button>
          <br />
          <button
            className="primary-text-blue"
            style={{
              border: "none !important",
              outline: "none !important",
              cursor: "pointer",
              backgroundColor: "transparent",
              padding: "3%",
              marginTop: "10px",
            }}
            onClick={() => setUserType("new")}
          >
            {`<`} Go Back
          </button>
        </div>
      </form>
    </div>
  );
};

const LandingPage = () => {
  const [userType, setUserType] = useState(null);
  const [previousData, setPreviousData] = useState({});
  const { loading, user } = useSelector((state) => state.app);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!isEmptyObject(user)) {
        navigate("/caregiver/assessments");
      }
    }
  }, [loading]);
  return (
    <section className="container-fluid w-100 m-0 p-0">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Caregiver | Precise Digital</title>
        <link rel="canonical" href={window.location.origin} />
      </Helmet>
      <div
        className="container-fluid row m-0 p-0"
        style={{ minHeight: "100vh" }}
      >
        {/* Left Side (Image/Background) */}
        <div className="col-12 col-md-6 caregiverBg text-white ">
          <img
            src={YouthCaregiverLogo}
            style={{ height: "25%", marginTop: "40vh" }}
            alt="Caregiver Background Image"
          />
          <h2 className="mt-2">
            Welcome to
            <br />
            Precise Digital Caregiver Platform
          </h2>
        </div>

        {/* Right Side (Content) */}
        <div
          className="col-12 col-md-6 bg-white d-flex flex-column align-items-center"
          style={{
            overflowY: "auto",
            minHeight: "100vh",
            padding: "1rem",
          }}
        >
          <div className="w-100 text-center" style={{ maxWidth: "500px" }}>
            <img
              src={YouthLogoDark}
              className="img-fluid"
              style={{ maxHeight: "157px", maxWidth: "236px" }}
              alt="Caregiver Logo"
            />
          </div>

          <div className="w-100" style={{ maxWidth: "500px" }}>
            {!userType && (
              <div className="container mt-3 mt-md-5 text-center p-3">
                <h3>Welcome, you are a...</h3>
                <div
                  className="d-flex flex-column flex-sm-row justify-content-center mt-4"
                  style={{ gap: "20px" }}
                >
                  <button
                    className="alternative-btn px-3 mb-2 mb-sm-0"
                    onClick={() => {
                      navigate("/dashboard/home/");
                    }}
                  >
                    Returning User
                  </button>
                  <button
                    className="primary-btn"
                    onClick={() => {
                      setUserType("new");
                    }}
                  >
                    New User
                  </button>
                </div>
              </div>
            )}

            <NewUserComponent
              setPreviousData={setPreviousData}
              setUserType={setUserType}
              userType={userType}
            />

            {userType === "step-2" && (
              <AdolescentDetails
                previousData={previousData}
                setUserType={setUserType}
                userType={userType}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingPage;
